import * as SwitchPrimitive from "@radix-ui/react-switch";
import * as React from "react";
import { cx } from "../internal/cx.js";

export type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>;

/**
 * Two-state on/off toggle. Use for boolean settings where the change
 * takes effect immediately (no Save button). For a boolean control
 * inside a form, prefer `<Checkbox>` instead — switches are for
 * preferences, checkboxes are for facts.
 */
export const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitive.Root>, SwitchProps>(
  function Switch({ className, ...props }, ref) {
    return (
      <SwitchPrimitive.Root ref={ref} className={cx("cw-v2-switch", className)} {...props}>
        <SwitchPrimitive.Thumb className="cw-v2-switch__thumb" />
      </SwitchPrimitive.Root>
    );
  },
);
Switch.displayName = "Switch";
